import { BaseFillMenuItemState } from "./BaseFillMenuItemState";




export class BfxBlotterOrdersContextMenuItemQuickFillState extends BaseFillMenuItemState {}
